import { ChangeDetectorRef } from '@angular/core';
import { MtnaResizableTable } from '@mtna/core-angular';
import { VariableSummary } from '@mtna/variable-service-core-ts';

import { CanLoadCtor, CanTableEditCtor, mixinEditableTable, mixinLoading } from '../core/common-behaviors';

export class RdsDataDictionaryTableBase extends MtnaResizableTable<VariableSummary> {
  get areColumnsSet(): boolean {
    throw new Error('Method not implemented.');
  }
  get maxAutoColWidth(): number {
    throw new Error('Method not implemented.');
  }
  get minColWidth(): number {
    throw new Error('Method not implemented.');
  }

  constructor(cdr: ChangeDetectorRef) {
    super(cdr);
  }

  getLargestContentWidth(id: string): number {
    throw new Error('Method not implemented.\nid: ' + id);
  }
}

// Boilerplate for applying mixins to RdsDataDictionaryTableComponent.
export const _RdsDataDictionaryTableMixinBase: CanLoadCtor & CanTableEditCtor<VariableSummary> & typeof RdsDataDictionaryTableBase =
  mixinLoading(mixinEditableTable(RdsDataDictionaryTableBase));
